/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hero_Search_PlaceholderInputs */

const en_directory_hero_search_placeholder = /** @type {(inputs: Directory_Hero_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search tools, e.g. 'coding assistant'...`)
};

const zh_directory_hero_search_placeholder = /** @type {(inputs: Directory_Hero_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索 AI 工具与场景，例如「视频生成 / 编程助手 / PPT / 写作」…`)
};

/**
* | output |
* | --- |
* | "Search tools, e.g. 'coding assistant'..." |
*
* @param {Directory_Hero_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hero_search_placeholder = /** @type {((inputs?: Directory_Hero_Search_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hero_Search_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hero_search_placeholder(inputs)
	return zh_directory_hero_search_placeholder(inputs)
});
export { directory_hero_search_placeholder as "directory.hero.search_placeholder" }